import React, { createRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Button, DatePicker, Pagination, Table } from '../../components';
import PrintIcon from '../../assets/icons/printer.png';
import { Globals, axios, Constants } from '../../utils';
import Menu from "../menu";

const INITIAL_FILTER = {
  since: null,
  until: null,
};

class ExchangeRateReport extends React.Component {

  state = {
    showCreate: false,
    selectedItem: null,
    form: { ...INITIAL_FILTER },
    data: [],
    page: 1,
    last_page: 1,
  }

  debounce = createRef();

  componentDidMount() {
    this.load();
  }

  load = async (page = 1) => {
    Globals.setLoading();
    const { form } = this.state;

    const filter = {
      user_id: this.props.user.id,
      since: form.since && moment(form.since,'DD-MM-YYYY').format('YYYY-MM-DD'),
      until: form.until && moment(form.until,'DD-MM-YYYY').format('YYYY-MM-DD'),
      page,
    };

    try {
      const res = await axios.post('admin/conversions/get-history', filter);
      this.setState({
        data: res.data.conversion.data,
        last_page: res.data.conversion.last_page,
        page,
      });

    } catch (error) {
      Globals.showError(error?.response?.data?.error || 'Ocurrió un error inesperado');
    }

    Globals.quitLoading();
  }

  change = async (value, target) => {
    await this.setState(s => ({ form: { ...s.form, [target]: value } }));

    if (target === 'search') {
      if (this.debounce.current) clearTimeout(this.debounce.current);
      this.debounce.current = setTimeout(async () => this.load(), 700);
    } else {
      this.load();
    }
  }

  canResetFilter = () => {
    return JSON.stringify(this.state.form) !== JSON.stringify(INITIAL_FILTER);
  }

  resetFilter = async () => {
    await this.setState({ form: { ...INITIAL_FILTER } });
    this.load();
  }

  print = async () => {
    Globals.setLoading();
    const { form } = this.state;

    try {
      const filter = {
        user_id: this.props.user.id,
        since: form.since && moment(form.since,'DD-MM-YYYY').format('YYYY-MM-DD'),
        until: form.until && moment(form.until,'DD-MM-YYYY').format('YYYY-MM-DD'),
        download: true,
      };

      const res = await axios.post('admin/conversions/get-history', filter);
      if (!res.data?.url) throw new Error();
      window.open(res.data.url);

    } catch (error) {
      Globals.showError('Ocurrió un error al generar el PDF. Intente nuevamente.');
    }

    Globals.quitLoading();
  }

  render() {

    const { data, form, last_page, page } = this.state;

    return (
      <Menu history={this.props.history}>
        <div id="conversion-report">
          <div className="row">
            <div className="col-2">
              <DatePicker
                color="white"
                label="Desde"
                className="filter"
                value={form.since}
                onChange={v => this.change(v,'since')}
              />
            </div>
            <div className="col-2">
              <DatePicker
                color="white"
                label="Hasta"
                className="filter"
                value={form.until}
                onChange={v => this.change(v,'until')}
              />
            </div>
            <div className="col-md ">
              {this.canResetFilter() && (
                <Button
                  color="transparent"
                  className="btn-align-bottom btn-filter ml-2"
                  onClick={this.resetFilter}
                >
                  <span>Limpiar</span>
                </Button>
              )}
            </div>
          </div>

          <Table
            title="Histórico BCV"
            header={['Fecha','Monto (Bs.)','Diferencia (%)']}
            emptyMessage="No hay notas de crédito registradas"
            data={data.length}
            right={
              <Button title="Imprimir" small="true" onClick={this.print}>
                <img src={PrintIcon} alt="Imprimir" />
              </Button>
            }
          >
            {data.map((item, index) => (
              <tr key={index}>
                <td>{ moment(item.created_at).format('DD/MM/YYYY hh:mm A') }</td>
                <td align="right">{ Globals.formatMiles(item.amount) }</td>
                <td align="right">
                  <span data-direction={item.direction}>
                    { Globals.formatMiles(item.diff_percentage) }
                  </span>
                </td>
              </tr>
            ))}
          </Table>

          <Pagination
            pages={last_page}
            active={page}
            onChange={page => this.load(page)}
          />
        </div>
      </Menu>
    )
  }
}

export default connect(state => ({
  user: state.user,
}))(ExchangeRateReport);